import { render, staticRenderFns } from "./AddPPM_biweekly.vue?vue&type=template&id=563f5d87&scoped=true"
import script from "./AddPPM_biweekly.vue?vue&type=script&lang=ts"
export * from "./AddPPM_biweekly.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_biweekly.vue?vue&type=style&index=0&id=563f5d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f5d87",
  null
  
)

export default component.exports